module.exports = __webpack_public_path__ + "img/icon_tab_all.64e9cf01.svg";